import type { User } from '../../auth/api';
import { useDeviceClass } from '../../../shared/hooks/useDeviceClass';
import { SettingsDesktopView, type SettingsSection } from '../views/SettingsDesktopView';
import { SettingsMobileView } from '../views/SettingsMobileView';
import { SettingsTabletView } from '../views/SettingsTabletView';

export function SettingsPage({ section = 'settings', user }: { section?: SettingsSection; user: User }) {
  const device = useDeviceClass();
  const props = { section, user };
  if (device === 'mobile') return <SettingsMobileView {...props} />;
  if (device === 'tablet') return <SettingsTabletView {...props} />;
  return <SettingsDesktopView {...props} />;
}
